var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiRrSparkles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-sparkles",
    transform: "translate(0.018 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72151",
    "data-name": "Group 72151",
    transform: "translate(-0.018 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72150",
    "data-name": "Group 72150",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91694",
    "data-name": "Path 91694",
    d: "M25.983,32a1.333,1.333,0,0,1-1.239-.837l-1.125-2.817L20.8,27.16a1.343,1.343,0,0,1,.047-2.476l2.784-1.055,1.116-2.789a1.344,1.344,0,0,1,2.477,0l1.121,2.8,2.8,1.121a1.343,1.343,0,0,1,0,2.477l-2.8,1.121-1.121,2.8A1.333,1.333,0,0,1,25.983,32ZM13.316,28a2.667,2.667,0,0,1-2.581-1.884L8.583,19.389,1.832,17.13A2.709,2.709,0,0,1,1.9,11.969L8.6,9.923l2.256-6.739A2.608,2.608,0,0,1,13.46,1.335a2.667,2.667,0,0,1,2.556,1.919l2.043,6.687,6.707,2.147a2.723,2.723,0,0,1,0,5.163L18.047,19.4,15.9,26.118A2.667,2.667,0,0,1,13.316,28Zm.149-23.969-2.549,7.388a1.333,1.333,0,0,1-.875.853L2.68,14.519l7.388,2.556a1.333,1.333,0,0,1,.848.857l2.36,7.373,2.44-7.373a1.333,1.333,0,0,1,.864-.864l7.373-2.359a.1.1,0,0,0,.027-.012l-7.4-2.429a1.333,1.333,0,0,1-.869-.881ZM24.359,15.979Zm2.957-6.644a1.333,1.333,0,0,1-1.293-1.009l-.476-1.907-1.911-.513a1.333,1.333,0,0,1,.045-2.587l1.867-.433.475-1.875a1.333,1.333,0,0,1,2.587,0L29.082,2.9l1.891.473a1.333,1.333,0,0,1,0,2.587l-1.891.473L28.61,8.326A1.333,1.333,0,0,1,27.317,9.335Z",
    transform: "translate(0.018 -0.002)",
    fill: "currentColor"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrSparkles);
export default __webpack_public_path__ + "static/media/fi-rr-sparkles.da6843c25cdf12364b0f351035e9e339.svg";
export { ForwardRef as ReactComponent };